function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-277,-67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "matrix(1.61997,0,0,1.61997,162.468,52.6294)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.54324,0,0,1.54324,70.9936,-1577.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.406,1041.1C5.521,1042.4 3.428,1045.1 3.063,1048.4C3.063,1049.5 3.895,1050.4 5,1050.4L19,1050.4C20.105,1050.4 20.938,1049.5 20.938,1048.4C20.572,1045.1 18.479,1042.4 15.594,1041.1C14.945,1042.4 13.583,1043.4 12,1043.4C10.417,1043.4 9.055,1042.4 8.406,1041.1Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.00025,1031.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,4C17,6.743 14.743,9 12,9C9.257,9 7,6.743 7,4C7,1.257 9.257,-1 12,-1C14.743,-1 17,1.257 17,4Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,1028.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,11C10.723,11 9.506,11.269 8.406,11.75C5.521,13.012 3.428,15.747 3.063,19C3.063,20.105 3.895,21 5,21L19,21C20.105,21 20.938,20.105 20.938,19C20.572,15.747 18.479,13.012 15.594,11.75C14.494,11.269 13.277,11 12,11Z",
    style: {
      fillRule: "nonzero"
    }
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.a7a97db0.svg";
export { ForwardRef as ReactComponent };